import { memo } from 'react';
import Avatar from '@mui/material/Avatar';
import _toUpper from 'lodash/toUpper';
import ErrorWrapper from '../ErrorWrapper/ErrorWrapper';

const BaseAvatar = ({ src, userable, sx, message = false }) => {
  return (
    <Avatar
      alt={userable || ''}
      src={src}
      sx={{
        width: 30, height: 30,
        fontSize: 14,
        fontWeight: 700,
        backgroundColor: 'primary.main',
        ...sx
      }}
    >
      {userable ? `${_toUpper(userable[message ? 0 : userable?.length - 2])}${_toUpper(userable[userable?.length - 1])}` : ''}
    </Avatar>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <BaseAvatar {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);